const selectColorMp3: {
  color: string;
  buttonColor: string;
}[] = [
  {
    color: "#7D66D9",
    buttonColor: "#4953B4",
  },
  {
    color: "#AF3C4D",
    buttonColor: "#4D455D",
  },
  {
    color: "#A75D5D",
    buttonColor: "#D3756B",
  },
  {
    color: "#95C6BC",
    buttonColor: "#EEAE80",
  },
  {
    color: "#332FD0",
    buttonColor: "#FB2576",
  },
  {
    color: "#FFAE00",
    buttonColor: "#3E00B3",
  },
];

export default selectColorMp3;
